enum MenuItem {
  Funds = 'funds',
  Settings = 'settings',
  Profile = 'profile',
  Trade = 'trade',
  LykkeStreams = 'lykke streams',
  BlockchainExplorer = 'blockchain explorer',
  Assets = 'assets',
  ApiKeys = 'api keys',
  FeesAndLimits = 'fees and limits'
}

export default MenuItem;
